<template>
  <div class="nav-component-root">
    <div class="nav_list">
      <div class="nav_list_left">
        <img src="./../assets/img/imglog.png" alt="log" />
      </div>
      <div :style="{ width : isLogin?'70%':'74%' }" class="nav_list_center">
        <ul class="navUl">
          <li
            v-for="(item, index) in menuList"
            :key="item.menuId"
            @mouseover="handlehover('over', index)"
            @mouseleave="handlehover('leave')"
            class="navli"
            @click="handledetail(item.menuId)"
          >
            <!-- <transition name="navDot"
              ><span
                class="navDot"
                v-show="showNavMenu == index ? true : false"
              ></span
            ></transition> -->
            <a>{{ item.label }}</a>
            <transition name="navMenu-fade">
              <ul
                v-show="showNavMenu == index ? true : false"
                class="navMenu"
                ref="navMenu"
              >
                <li
                  v-for="(child, cIndex) in item.children"
                  :key="child.menuId"
                  class="menuList"
                  @mouseenter="hoverchild('enter', cIndex)"
                  @mouseleave="hoverchild('leave')"
                  @click="handleSubmenu(child)"
                >
                  <p class="menuList_name">
                    <transition name="childDot"
                      ><div class="childDotBox">
                        <span
                          class="childDot"
                          v-show="showchildMenu == cIndex"
                        ></span></div
                    ></transition>
                    {{ child.label }}
                  </p>
                  <p class="menuList_info">{{ child.note }}</p>
                  <i
                    class="el-icon-arrow-right"
                    v-if="child.children && child.children.length > 0"
                  ></i>
                  <transition name="navChildMenu">
                    <ul
                      class="navChildMenu"
                      ref="navChildMenu"
                      v-show="showchildMenu == cIndex"
                    >
                      <li
                        v-for="children in child.children"
                        :key="children.menuId"
                        class="childMenuList"
                        @mouseenter="hoverchildren('enter', cIndex)"
                        @mouseleave="hoverchildren('leave')"
                      >
                        <p
                          @click="handleThreeMenu(children)"
                          :title="children.label"
                        >
                          <transition
                            ><div class="childrenDotBox">
                              <span
                                class="childrenDot"
                                v-show="showchildrenMenu == cIndex"
                              ></span></div
                          ></transition>
                          {{ children.label }}
                        </p>
                      </li>
                    </ul>
                  </transition>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
    
      <div class="nav_list_right" v-if="isLogin">
        <div v-if="isLogin && isGSM" @click="tohelp" class="help" title="help">
        <img src="../assets/img/logo.png" />
      </div>
        <div class="headPortrait">
          {{
            userData.name
              ? userData.name.substring(0, 1)
              : ""
          }}
        </div>
        <div
          class="userDropdown"
          @mouseenter="hoverUser('enter')"
          @mouseleave="hoverUser('leave')"
        >
        
          <div v-if="userData.code" class="user-content">
            <p :title="userData.name">
              {{userData.name }}
            </p>
            <p :title="userData.code">
              {{userData.code }}
            </p>
          </div>
          <div v-else class="user-content">
            <p :title="userData.surname">
              {{ userData.surname }}
            </p>
            <p :title="userData.name">
              {{ userData.name }}
            </p>
          </div>
          <i class="el-icon-arrow-down"></i>
          <transition name="showUser">
            <ul class="userDropdown_info" v-show="showUser">
              <li class="changePassword" @click="personalCenter">
                <div class="userInfoDot"><span></span></div>
                Personal Center
              </li>
              <li class="logOut" @click="logOut">
                <div class="userInfoDot"><span></span></div>
                Log Out
              </li>
            </ul>
          </transition>
        </div>
      </div>
      <!-- <div class="nav_list_right" v-else>
        <span @click="goLogin(true)">Sangfor Login</span>
        <span @click="goLogin()">Partner Login</span>
        <span @click="goLogin()">Partner Login(EMEA)</span>
      </div> -->
      <el-dropdown @command="handleClickLogin" v-else>
        <el-button type="primary">
          Login<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
              <el-dropdown-item  :command="1">Sangfor Login</el-dropdown-item>
              <el-dropdown-item  :command="2">Partner Login (Non EMEA)</el-dropdown-item>
              <el-dropdown-item  :command="3">Partner Login (EMEA)</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="contact">
        <a
          href="https://www.sangfor.com/en/about-us/contact-us/contact-us-form"
          target="_blank"
          >Email Us</a
        >
      </div>
      
    </div>
    <!-- 特殊栏目：Technical Material（menuId 37）下方横幅 -->
    <div v-if="technicalMaterialSupport" class="supportNotice">
      <div class="supportNotice__inner">
        <span class="supportNotice__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4 9v6a2 2 0 002 2h1.5l4.5 3.2V3.8L7.5 7H6a2 2 0 00-2 2z"
              fill="#cfe4ff"
              stroke="#0d5bd8"
              stroke-width="1.2"
              stroke-linejoin="round"
            />
            <path
              d="M17 8.5c1.2 1 1.8 2.4 1.8 3.5s-.6 2.5-1.8 3.5"
              fill="none"
              stroke="#0d5bd8"
              stroke-width="1.4"
              stroke-linecap="round"
            />
            <path
              d="M19 6.5c2 1.8 3 3.8 3 5.5s-1 3.7-3 5.5"
              fill="none"
              stroke="#5a9cff"
              stroke-width="1.2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <p class="supportNotice__text">
          All technical docs have been migrated to Sangfor Support. No new updates on this platform. Please use the new platform.
        </p>
        <button
          type="button"
          class="supportNotice__link"
          @click="openSupportWindow(technicalMaterialSupport.menuUrl)"
        >
          Visit Sangfor Support
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { outGsm, outPp, checkLoginApi, removeIdtToken, removeTokenByPIDT } from "../api/login";
import { mapState } from 'vuex'
export default {
  name: "navComponment",
  data() {
    return {
      isLogin: false,
      hover: false,
      showUser: false,
      isActive: 0,
      showNavMenu: -1,
      showchildMenu: -1,
      showchildrenMenu: -1,
      userData: {},
      menuList: [],
      isGSM: false,
    };
  },
  computed:{
    // isLogin(){
    //   return !!localStorage.getItem("library_token");
    // },
     ...mapState(['userInfo']),
    technicalMaterialSupport() {
      return (
        this.menuList.find(
          (item) =>
            Number(item.menuId) === 37 &&
            item.menuLevel == 1 &&
            item.menuUrl
        ) || null
      );
    },
  },
  watch: {
    // 监听vuex中的数据
    userInfo(newValue, oldValue) {
      this.userData = newValue ? { ...newValue } : {}
      this.isLogin = !!newValue
       if (this.isLogin) {
        this.checkLogin();
      } 
    },
    // 监听vuex中菜单数据的变化
    '$store.state.menuData': {
      handler(newValue) {
        console.log('菜单数据变化:', newValue);
        if (newValue && newValue.length > 0) {
          this.menuList = newValue;
          // 移除id为3298的菜单
          this.menuList = this.removeMenu(this.menuList,3298);
          console.log('更新菜单列表:', this.menuList);
        }
      },
      immediate: true,
      deep: true
    },
  },
  created() {
    const menuData = this.$store.getters.menuData;
    if (menuData && menuData.length > 0) {
      this.$set(this, 'menuList', menuData);
    } else {
      this.menuList = [];
    }
    
    let userInfo = localStorage.getItem("library_userInfo")
      ? JSON.parse(localStorage.getItem("library_userInfo"))
      : "";
    this.userData = userInfo || {}
    this.isLogin = !!localStorage.getItem("library_token")
    this.$store.commit("SET_USERINFO", userInfo);
  },
  mounted(){
    this.$nextTick(()=>{
      if (this.isLogin) {
        this.checkLogin();
      }
    });
  },
  methods: {
    handleClickLogin(flag) {
       const {NODE_ENV, VUE_APP_CAS_LOGIN,VUE_APP_IDT_LOGIN,VUE_APP_PARTNER_REDIRECT_URI,VUE_APP_PARTNER_EU_REDIRECT_URI ,VUE_APP_EU_LOGIN,VUE_APP_ML_HOST,VUE_APP_SANGFOR_REDIRECT_URI,VUE_APP_SANGFOR_EU_REDIRECT_URI} = process.env
       localStorage.setItem('library_login_type', flag == 1 ? 'sangfor' : 'partner')
       let hostName = window.location.hostname
       let redirectUri = flag == 1 && hostName == VUE_APP_ML_HOST ? VUE_APP_SANGFOR_REDIRECT_URI : VUE_APP_SANGFOR_EU_REDIRECT_URI
       if(flag == 2 || flag == 3) redirectUri = flag == 2 ? VUE_APP_PARTNER_REDIRECT_URI : VUE_APP_PARTNER_EU_REDIRECT_URI
       let origin = flag == 1 ? VUE_APP_IDT_LOGIN :  flag == 2 ? VUE_APP_CAS_LOGIN : VUE_APP_EU_LOGIN
       let casLogin = origin + '&redirect_uri=' + redirectUri
       location.replace(casLogin);
    },

    checkLogin() {
      checkLoginApi().then((res) => {
        const { rows } = res?.data;
        if (rows && rows.userId) {
          this.isGSM = true;
        }else{
          this.isGSM = false;
        }
      });
    },
    tohelp() {
      const token = localStorage.getItem("library_token");
      if (token) {
        if (process.env.NODE_ENV === "development") {
          window.open(
            `http://localhost:8088/gptAssistant?library_token=${localStorage.getItem(
              "library_token"
            )}`
          );
        } else {
          window.open("/gptAssistant");
        }
      }
      else {
        // this.handleLogin();
        this.$message.error('Please log in')
      }
    },
    handlehover(data, index) {
      if (data === "over") {
        this.showNavMenu = index;
      } else {
        this.showNavMenu = -1;
      }
    },
    openSupportWindow(url) {
      if (!url) return;

      window.open(url, "_blank");
    },
    hoverchild(data, index) {
      if (data === "enter") {
        this.showchildMenu = index;
      } else {
        this.showchildMenu = -1;
      }
    },
    hoverchildren(data, index) {
      if (data === "enter") {
        this.showchildrenMenu = index;
      } else {
        this.showchildrenMenu = -1;
      }
    },
    hoverUser(data) {
      if (data === "enter") {
        this.showUser = true;
      } else {
        this.showUser = false;
      }
    },
    //点击跳转更改密码
    personalCenter() {
      this.$router.push({ path: "/personalCenter", query: { index: "1" } });
    },
    //点击跳转登录
    handleLogin() {
      this.$router.push({ path: "/login" });
    },
    //点击三级菜单
    handleThreeMenu(data) {
      let detailId = data.menuId;
      localStorage.setItem("library_tree", JSON.stringify(data));
      console.log(data);
      if (data.articleType == 0) {
        this.$router.push({
          name: "indexPage",
          params: { data: data, detailId: detailId },
          query: { module: data.menuId },
        });
      } else {
        this.$router.push({
          name: "mdArticle",
          params: { data: data, detailId: detailId },
          query: { module: data.menuId },
        });
      }
    },
    //点击一级菜单
    handledetail(id) {
      if (id == 1) {
        this.$router.push({ path: "/home" });
      }
    },
    //点击二级菜单
    handleSubmenu(data) {
      // if(!data.children||data.children.length<1){
      //   let detailId=data.menuId
      //   data=JSON.stringify(data)
      //   this.$router.push({ path: "/indexPage" ,query:{data:data,detailId:detailId}});
      // }
    },
    //登出
    logOut() {
       const {NODE_ENV,VUE_APP_ML_HOST} = process.env
      let hostName = window.location.hostname
      let data = localStorage.getItem("library_login_type");
      let methodFunc = data == 'partner' ? removeTokenByPIDT : removeIdtToken;
      let params = {
        token: localStorage.getItem("library_token"),
        idtToken: localStorage.getItem('token_by_code'),
        type: hostName != VUE_APP_ML_HOST ? "eu" : "mo"
      };
      if(data != 'partner') {
        delete params.idtToken
        params.token = localStorage.getItem('token_by_code')
      }
      methodFunc(params).then(res=>{
          if (res.data.code == 0) {
            localStorage.removeItem("library_token");
            localStorage.removeItem("library_userInfo");
            localStorage.removeItem("token_by_code");
            localStorage.removeItem('library_login_type')
            location.replace('/')
          }
        }).catch(err=>{
          this.$message.warning('请重试')
        })
      // if (
      //   localStorage.getItem("library_userType") &&
      //   localStorage.getItem("library_userType") == "pp"
      // ) {
      //   outPp(params)
      //     .then((res) => {
      //       localStorage.removeItem("library_token");
      //       localStorage.removeItem("library_userInfo");
      //       localStorage.removeItem("library_userType");
      //       var url = "http://" + location.host + "/";
      //       location.href = url;
      //     })
      //     .catch(() => {
      //       localStorage.removeItem("library_token");
      //       localStorage.removeItem("library_userInfo");
      //       localStorage.removeItem("library_userType");
      //       var url = "http://" + location.host + "/";
      //       location.href = url;
      //     });
      // } else if (
      //   localStorage.getItem("library_userType") &&
      //   localStorage.getItem("library_userType") == "gsm"
      // ) {
      //   outGsm(params)
      //     .then((res) => {
      //       localStorage.removeItem("library_token");
      //       localStorage.removeItem("library_userInfo");
      //       localStorage.removeItem("library_userType");
      //       var url = "http://" + location.host + "/";
      //       location.href = url;
      //     })
      //     .catch(() => {
      //       localStorage.removeItem("library_token");
      //       localStorage.removeItem("library_userInfo");
      //       localStorage.removeItem("library_userType");
      //       var url = "http://" + location.host + "/";
      //       location.href = url;
      //     });
      // }else if (
      //   localStorage.getItem("library_userType") &&
      //   localStorage.getItem("library_userType") == "idt"
      // ){
      //   removeIdtToken(localStorage.getItem('token_by_code')).then(res=>{
      //     if (res.data.code == 0) {
      //       localStorage.removeItem("library_token");
      //       localStorage.removeItem("library_userInfo");
      //       localStorage.removeItem("library_userType");
      //       localStorage.removeItem("token_by_code");
      //       localStorage.removeItem('library_login_type')
      //       location.replace('/')
      //     }
      //   }).catch(err=>{
      //     this.$message.warning('请重试')
      //   })
      // }
    },
    // 移除指定menuId的菜单
    removeMenu(menuList,menuId) {
      const newMenuList = [];
      menuList.forEach(item => {
        if(Number(item.menuId) !== Number(menuId)) {
          const newItem = { ...item };
          if(newItem.children && newItem.children.length) {
            newItem.children = this.removeMenu(newItem.children,menuId);
          }
          newMenuList.push(newItem);
        }else{
          return;
        }
        
      });
      return newMenuList;
    },

  },
};
</script>

<style scoped lang="scss">
.nav-component-root {
  position: relative;
  width: 100%;
}
.supportNotice {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  background: linear-gradient(180deg, #f2f7fd 0%, #e8f1fa 100%);
  border-top: 1px solid #d8e6f4;
  border-bottom: 1px solid #cfdfea;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
  .supportNotice__inner {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 10px 14px;
    width: 100%;
    max-width: 1200px;
  }
  .supportNotice__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .supportNotice__text {
    margin: 0;
    flex: 0 1 auto;
    min-width: 0;
    font-size: 16px;
    line-height: 1.55;
    color: red;
    text-align: center;
    white-space: nowrap;
  }
  .supportNotice__link {
    flex-shrink: 0;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    font: inherit;
    font-size: 16px;
    line-height: 1.55;
    font-weight: 600;
    color: #0d39a8;
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
      color: #082a7a;
    }
  }
}
@media (max-width: 1200px) {
  .supportNotice {
    .supportNotice__inner {
      flex-wrap: wrap;
    }
    .supportNotice__text {
      white-space: normal;
    }
  }
}
.nav_list {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  .help {
    cursor: pointer;
    margin-right: 20px;
  }
  .nav_list_left {
    width: 9%;
    height: 52px;
    cursor: pointer;
    img {
      width: auto;
      height: 100%;
    }
  }
  .nav_list_center {
    width: 74%;
    height: 100%;
    padding: 0 200px 0 80px;
    .navUl {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .navli {
        position: relative;
        padding: 0 14px;
        height: 100%;
        display: flex;
        align-items: center;
        &:hover {
          background: #eff1f7;
          a {
            color: #0d39a8;
          }
        }
        .navDot {
          position: absolute;
          top: 43px;
          left: 0;
          width: 6px;
          height: 6px;
          background: #65bb10;
          border-radius: 50%;
        }
        .navDot-enter-active {
          transition: all 0.3s ease;
        }
        .navDot-leave-active {
          transition: all 0.1s ease;
        }
        .navDot-enter {
          transform: translateX(-5px);
        }
        .navDot-leave-to {
          opacity: 0;
        }
        a {
          color: #9e9fb7;
          text-decoration: none;
          font-size: 20px;
          font-weight: 600;
        }
        .navMenu {
          position: absolute;
          top: 90px;
          left: -100px;
          background: #fff;
          padding: 15px 0;
          // box-shadow: 1px 1px 6px #DAE2F5;
          // box-shadow: 9px 10px 10px #c1c8db;
          border-radius: 8px;
          z-index: 2999;
          .menuList {
            position: relative;
            padding: 10px 60px 10px 30px;
            &:hover {
              background: #eff1f7;
              .menuList_name {
                color: #51555e;
                .childDotBox {
                  width: 16px;
                }
              }
            }
            .menuList_name {
              white-space: nowrap;
              font-size: 18px;
              color: #7f8394;
              text-align: left;
              display: flex;
              align-items: center;
              .childDotBox {
                width: 6px;
                transition: width 0.3s;
                display: flex;
                .childDot {
                  width: 6px;
                  height: 6px;
                  background: #65bb10;
                  border-radius: 50%;
                  margin-right: 10px;
                  transition: all 0.5s;
                }
              }
            }
            .menuList_info {
              white-space: nowrap;
              font-size: 14px;
              color: #ababae;
              text-align: left;
              margin-top: 8px;
            }
            .el-icon-arrow-right {
              position: absolute;
              top: 50%;
              transform: translate(0, -50%);
              right: 20px;
              font-size: 20px;
              color: #6b74f2;
            }
            .navChildMenu {
              width: 400px;
              background: #fff;
              border-radius: 8px;
              position: absolute;
              top: 0;
              right: -400px;
              z-index: 2999;
              // box-shadow: 9px 10px 38px #c1c8db;
              .childMenuList {
                padding: 5px 30px;
                border-radius: 8px;
                &:hover {
                  background: #eff1f7;
                  p {
                    color: #51555e;
                    .childrenDotBox {
                      width: 16px;
                    }
                  }
                }
                p {
                  width: 100%;
                  text-align: left;
                  font-size: 16px;
                  color: #7f8394;
                  padding: 15px 0;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  .childrenDotBox {
                    width: 6px;
                    transition: width 0.3s;
                    display: flex;
                    .childrenDot {
                      width: 6px;
                      height: 6px;
                      background: #65bb10;
                      border-radius: 50%;
                      margin-right: 10px;
                      transition: all 0.3s;
                    }
                  }
                }
              }
            }
            .navChildMenu-enter-active,
            .navChildMenu-leave-active {
              transition: opacity 0.3s;
            }
            .navChildMenu-enter,
            .navChildMenu-leave-to {
              opacity: 0;
            }
          }
        }
        .navMenu-fade-enter-active,
        .navMenu-fade-leave-active {
          transition: opacity 0.3s;
        }
        .navMenu-fade-enter,
        .navMenu-fade-leave-to {
          opacity: 0;
        }
      }
    }
  }
  .nav_list_right {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: end;
    position: relative;
    height: 100%;
    cursor: pointer;
    >span{
          font-size: 13px;
          padding: 10px 6px;
          border-radius: 4px;
          background: #1688e2;
          color: #fff;
          cursor: pointer;
          margin-right: 16px;
    }
    .headPortrait {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      color: red;
      font-size: 18px;
      text-align: center;
      line-height: 44px;
      background: #ccc;
      cursor: default;
    }
    .userDropdown {
      // width: 150px;
      padding: 0 16px;
      font-size: 16px;
      color: #7a7b80;
      font-weight: 400;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      z-index: 999;
      .user-content {
        width: auto;
        p {
          max-width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      i {
        margin-left: 10px;
      }
      .userDropdown_info {
        width: 230px;
        position: absolute;
        top: 90px;
        right: 1px;
        background: #ffffff;
        box-shadow: 9px 10px 38px #c1c8db;
        border-radius: 8px;
        padding: 13px 30px;
        z-index: 9999;
        li {
          padding: 13px 10px;
          text-align: left;
          color: #7a7b80;
          display: flex;
          .userInfoDot {
            width: 6px;
            transition: width 0.3s;
            display: flex;
            align-items: center;
            span {
              width: 6px;
              height: 6px;
              background: #65bb10;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
          &:hover {
            color: #51555e;
            .userInfoDot {
              width: 16px;
            }
          }
        }
      }
      .showUser-enter-active,
      .showUser-leave-active {
        transition: opacity 0.3s;
      }
      .showUser-enter,
      .showUser-leave-to {
        opacity: 0;
      }
      .userName {
        width: 90px;
        word-break: keep-all;
      }
    }
  }
  .contact {
    padding: 10px 20px;
    border-radius: 50px;
    background: #232949;
    a {
      color: #fff;
    }
    cursor: pointer;
  }
}
ul,
li {
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
  margin: 0;
}
body{
  margin: 0;
  padding: 0;
}
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
fieldset, button, input, textarea, /* form elements 表单元素 */
th, td,div,header {
  /* table elements 表格元素 */
  box-sizing: border-box;
}

  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-dropdown-menu{
    transform: translateX(55px);
  }
  .el-button.el-dropdown-selfdefine{
    font-size: 16px;
  }
</style>
